import { composeIO } from 'react-compose-io'
import { itemNotaFiscalIO } from './ItemNotaFiscal.IO'
import { ItemNotaFiscalView } from './ItemNotaFiscal.View'

export const ItemNotaFiscal = composeIO(ItemNotaFiscalView, itemNotaFiscalIO)
